import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramariComponent } from './programari.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        ProgramariComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [ProgramariComponent],
})
export class ProgramariModule { }
